import { render, staticRenderFns } from "./dashDocAlert.vue?vue&type=template&id=4a76f2fd&"
import script from "./dashDocAlert.vue?vue&type=script&lang=js&"
export * from "./dashDocAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports